import { InfrastructurePageProvider } from "../../context/InfrastructurePageContext";
import ServicePageLayout from "./ServicePageLayout";

export default function Infrastructure() {
  return (
    <InfrastructurePageProvider>
      <ServicePageLayout showHostingPlans />
    </InfrastructurePageProvider>
  );
}
